import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const Eye = ({ size = 20, color = Colors.black, onClick }: SvgProps) => (
  <SvgIcon size={size} onClick={onClick}>
    <svg
      color={color}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.42442 10.9739C2.13978 10.3546 2.13978 9.64019 2.42442 9.02093C3.742 6.15442 6.63866 4.16406 10.0002 4.16406C13.3617 4.16406 16.2584 6.15442 17.576 9.02093C17.8606 9.64019 17.8606 10.3546 17.576 10.9739C16.2584 13.8404 13.3617 15.8307 10.0002 15.8307C6.63866 15.8307 3.74201 13.8404 2.42442 10.9739Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.5002 9.9974C12.5002 11.3781 11.3809 12.4974 10.0002 12.4974C8.61948 12.4974 7.50019 11.3781 7.50019 9.9974C7.50019 8.61668 8.61948 7.4974 10.0002 7.4974C11.3809 7.4974 12.5002 8.61668 12.5002 9.9974Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  </SvgIcon>
);
